import {selectVisibleGlobalModal} from '../../state/selectors/modal';
import {hideModal} from '../../state/slice/modal';
import {dispatch, getState} from '../../state/store';

const hideModalByType = (modalType) => {
    const modal = selectVisibleGlobalModal(modalType)(getState());

    if (modal) {
        dispatch(hideModal(modalType));
    }
};

export default {hideModalByType};
